import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import FreeTools from "./pages/FreeTools";
import CompoundInterest from "./pages/CompoundInterest";
import FinancialIndependence from "./pages/FinancialIndependence";
import Contact from "./pages/Contact";

const App = () => {
  return (
    <Router>
      <div className="app-container">
        {/* Header */}
        <Header />

        {/* Main Content */}
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/free-tools" element={<FreeTools />} />
            <Route path="/compound-interest" element={<CompoundInterest />} />
            <Route
              path="/financial-independence"
              element={<FinancialIndependence />}
            />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>

        {/* Footer */}
        <Footer />
      </div>
    </Router>
  );
};

export default App;
